import React, { useContext, useEffect, useRef } from 'react'
import { store } from '../../stores/pages'
import { Button } from 'reactstrap'
import debounce from 'debounce'
import FormFields from '../FormFields'

export default function ThemeEditorSidebar() {
  const context = useContext(store)
  const formRef = useRef(null)
  const { fields, blocks, templateId, dispatch, actions } = context

  const handleOnChange = (e) => {
    dispatch({ type: actions.UPDATE_HTML })
  }

  const debouncedOnChange = debounce(handleOnChange, 500)

  return (
    <>
      <Button className="form-control-hidden">Generate Preview</Button>
      <div className="producer-form-container pt-0">
        <div className="producer-form-mobile-header">Enter Your Data</div>
        <input type="hidden" name="template_id" value={templateId} />
        <FormFields {...context} onChange={debouncedOnChange} fields={fields} />
      </div>
      <Button
        color="primary"
        size="lg"
        className="producer-mobile-action-button"
      >
        Update Preview
      </Button>
    </>
  )
}
